import React from "react";
import { Switch, Route } from "react-router-dom";
import SignUp from "./SignUp";
import Reset from "./Reset";
import Login from "./Login";
import Activation from "./Activation";
import Layout from "app/layout/Layout";
import { StyledBanner } from "app/home";

const Routes = () => {
  return (
    <Switch>
      <Route path="/login" render={props => <Login {...props} />} />
      <Route path="/signup" component={SignUp} />
      <Route path="/reset" component={Reset} />
      <Route path="/activate" component={Activation} />
    </Switch>
  );
};

const AuthLayout = () => {
  return <Layout banner={<StyledBanner compact />} main={<Routes />} />;
};

export default AuthLayout;



// WEBPACK FOOTER //
// ./src/app/auth/index.js